import NewCustomerHub from './NewCustomerHub';

export default NewCustomerHub;
